import { TIMEFRAME, STATUS_FILTER, TODO_STATUS } from '../constants';
import { getTimeframes } from './timeframes';

/**
 * Filter todos by timeframe
 * @param {Array} todos - Array of todos
 * @param {String} timeframe - Timeframe filter key
 * @returns {Array} - Filtered todos
 */
export const filterByTimeframe = (todos, timeframe) => {
  if (timeframe === TIMEFRAME.ALL) return todos;

  const { startOfToday, endOfWeek, endOfNextWeek, endOfNextMonth } = getTimeframes();

  return todos.filter(todo => {
    if (!todo.dueDate) return false;
    const dueDate = new Date(todo.dueDate);

    switch (timeframe) {
      case TIMEFRAME.OVERDUE:
        return dueDate < startOfToday;
      case TIMEFRAME.THIS_WEEK:
        return dueDate >= startOfToday && dueDate <= endOfWeek;
      case TIMEFRAME.NEXT_WEEK:
        return dueDate > endOfWeek && dueDate <= endOfNextWeek;
      case TIMEFRAME.NEXT_MONTH:
        return dueDate > endOfNextWeek && dueDate <= endOfNextMonth;
      case TIMEFRAME.LATER:
        return dueDate > endOfNextMonth;
      default:
        return true;
    }
  });
};

/**
 * Filter todos by status
 * @param {Array} todos - Array of todos
 * @param {String} status - Status filter key
 * @returns {Array} - Filtered todos
 */
export const filterByStatus = (todos, status) => {
  if (status === STATUS_FILTER.ALL) return todos;
  if (status === STATUS_FILTER.ACTIVE) {
    return todos.filter(t => t.status !== TODO_STATUS.DONE);
  }
  if (status === STATUS_FILTER.COMPLETED) {
    return todos.filter(t => t.status === TODO_STATUS.DONE);
  }
  return todos;
};

/**
 * Calculate timeframe counts for tasks
 * @param {Array} todos - Array of todos
 * @returns {Object} - Counts by timeframe
 */
export const getTimeframeCounts = (todos) => {
  const { startOfToday, endOfWeek, endOfNextWeek, endOfNextMonth } = getTimeframes();

  return {
    overdue: todos.filter(
      t => t.dueDate && t.status !== TODO_STATUS.DONE && new Date(t.dueDate) < startOfToday
    ).length,
    thisWeek: todos.filter(
      t => t.dueDate && t.status !== TODO_STATUS.DONE && 
      new Date(t.dueDate) >= startOfToday && new Date(t.dueDate) <= endOfWeek
    ).length,
    nextWeek: todos.filter(
      t => t.dueDate && t.status !== TODO_STATUS.DONE && 
      new Date(t.dueDate) > endOfWeek && new Date(t.dueDate) <= endOfNextWeek
    ).length,
    nextMonth: todos.filter(
      t => t.dueDate && t.status !== TODO_STATUS.DONE && 
      new Date(t.dueDate) > endOfNextWeek && new Date(t.dueDate) <= endOfNextMonth
    ).length,
    later: todos.filter(
      t => t.dueDate && t.status !== TODO_STATUS.DONE && 
      new Date(t.dueDate) > endOfNextMonth
    ).length,
  };
};

export default {
  filterByTimeframe,
  filterByStatus,
  getTimeframeCounts,
};
